import { useMemo } from "react";
import { useGetPreviewAccountsByEntityQuery } from "~/graphql/supergraphHooks";
import type { PreviewSelectOption } from "../types";

type UsePreviewPositionsResult = {
  accounts: PreviewSelectOption[];
  loading: boolean;
};

export const usePreviewPositions = (entityId: string): UsePreviewPositionsResult => {
  const { data, loading } = useGetPreviewAccountsByEntityQuery({
    variables: { entityId },
    skip: !entityId,
  });

  const accounts = useMemo(
    () =>
      (data?.investmentEntity?.activeAccounts ?? []).map((a) => ({
        id: a.id,
        name: a.name,
      })),
    [data],
  );

  return { accounts, loading };
};
